// Customer Authentication Page translations
export const customerAuthTranslations = {
    en: {
        // Main actions
        signIn: "Sign In",
        register: "Create Account",
        emailAddress: "Email Address",
        password: "Password",
        sendSignInLink: "Send Sign-In Link",
        signInWithPassword: "Sign In",
        createAccount: "Create Account",

        // Email verification
        checkYourEmail: "Check Your Email",
        weveSentLink: "We've sent a sign-in link to:",
        noteUseDevice: "Note: Please use the same device to open the link.",
        checkSpam: "Check your spam folder if you don't see the email.",
        emailFrom: "Email sent from raffak.store",
        resendLink: "Resend Link",

        // Toggle options
        useEmailLink: "Use Email Link Instead",
        usePassword: "Use Password Instead",
        alreadyHaveAccount: "Already have an account? Sign in",
        needAccount: "Need an account? Register",

        // Password reset
        forgotPassword: "Forgot Password?",
        resetPassword: "Reset Password",
        sendResetEmail: "Send Reset Email",
        passwordResetSent: "Password Reset Email Sent",
        resetEmailMessage: "We've sent password reset instructions to:",
        resetEmailNote: "Follow the link in the email to reset your password.",
        backToSignIn: "Back to Sign In"
    },
    ar: {
        // Main actions
        signIn: "تسجيل الدخول",
        register: "إنشاء حساب",
        emailAddress: "عنوان البريد الإلكتروني",
        password: "كلمة المرور",
        sendSignInLink: "إرسال رابط تسجيل الدخول",
        signInWithPassword: "تسجيل الدخول",
        createAccount: "إنشاء حساب",

        // Email verification
        checkYourEmail: "تحقق من بريدك الإلكتروني",
        weveSentLink: "أرسلنا رابط تسجيل الدخول إلى:",
        noteUseDevice: "ملاحظة: يرجى استخدام نفس الجهاز لفتح الرابط.",
        checkSpam: "تحقق من مجلد البريد العشوائي إذا لم تجد البريد الإلكتروني.",
        emailFrom: "تم إرسال البريد من raffak.store",
        resendLink: "إعادة إرسال الرابط",

        // Toggle options
        useEmailLink: "استخدم رابط البريد الإلكتروني بدلاً من ذلك",
        usePassword: "استخدم كلمة المرور بدلاً من ذلك",
        alreadyHaveAccount: "لديك حساب بالفعل؟ سجل الدخول",
        needAccount: "تحتاج حساب؟ سجل الآن",

        // Password reset
        forgotPassword: "نسيت كلمة المرور؟",
        resetPassword: "إعادة تعيين كلمة المرور",
        sendResetEmail: "إرسال بريد إعادة التعيين",
        passwordResetSent: "تم إرسال بريد إعادة تعيين كلمة المرور",
        resetEmailMessage: "أرسلنا تعليمات إعادة تعيين كلمة المرور إلى:",
        resetEmailNote: "اتبع الرابط الموجود في البريد الإلكتروني لإعادة تعيين كلمة المرور.",
        backToSignIn: "العودة إلى تسجيل الدخول"
    }
};

// Translation hook for customer auth
export const useCustomerAuthTranslation = (language = 'en') => {
    const t = (key, replacements = {}) => {
        let translation = customerAuthTranslations[language]?.[key] || customerAuthTranslations['en'][key] || key;

        // Handle string replacements like {message}
        Object.keys(replacements).forEach(placeholder => {
            translation = translation.replace(new RegExp(`{${placeholder}}`, 'g'), replacements[placeholder]);
        });

        return translation;
    };

    return { t };
};